import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n                border: 0;\n                clip: rect(1px, 1px, 1px, 1px);\n                height: 1px;\n                overflow: hidden;\n                padding: 0;\n                position: absolute;\n                white-space: nowrap;\n                width: 1px;\n              "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n            bottom: ", "px;\n            left: ", "px;\n            position: fixed;\n            z-index: ", ";\n            @media (max-width: 560px) {\n              bottom: 0;\n              left: 0;\n            }\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n                    ", "\n                    ", "\n                  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/** @jsx jsx */
import { Children, createContext, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { easeIn, ExitingPersistence, SlideIn } from '@atlaskit/motion';
import Portal from '@atlaskit/portal';
import { gridSize as getGridSize, layers } from '@atlaskit/theme/constants';
var gridSize = getGridSize();
export var flagWidth = gridSize * 50;
export var flagAnimationTime = 400;
var flagBottom = gridSize * 6;
var flagLeft = gridSize * 10;
export var FlagGroupContext = /*#__PURE__*/createContext({
  dismissAllowed: function dismissAllowed() {
    return false;
  }
});
export function useFlagGroup() {
  return useContext(FlagGroupContext);
} // transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition

var baseStyles = "\n  bottom: 0;\n  position: absolute;\n  width: ".concat(flagWidth, "px;\n  transition: transform ").concat(flagAnimationTime, "ms ease-in-out;\n\n  @media (max-width: 560px) {\n    width: 100vw;\n  }\n\n  &:first-of-type {\n    transition: none;\n    transform: translate(0,0);\n  }\n\n  &:nth-of-type(n + 2) {\n    animation-duration: 0ms;\n    transform: translateX(0) translateY(100%) translateY(").concat(2 * gridSize, "px);\n  }\n\n  /* Layer the 'primary' flag above the 'secondary' flag */\n  &:nth-of-type(1) {\n    z-index: 5;\n  }\n  &:nth-of-type(2) {\n    z-index: 4;\n  }\n\n  &:nth-of-type(n + 4) {\n    visibility: hidden;\n  }\n");

var FlagGroup = function FlagGroup(props) {
  var id = props.id,
      _props$label = props.label,
      label = _props$label === void 0 ? 'Flag notifications' : _props$label,
      _props$labelTag = props.labelTag,
      LabelTag = _props$labelTag === void 0 ? 'h2' : _props$labelTag,
      children = props.children,
      onDismissed = props.onDismissed;

  var renderChildren = function renderChildren() {
    return children ? Children.map(children, function (flag, index) {
      var isDismissAllowed = index === 0;
      var id = flag.props.id;
      return jsx(SlideIn, {
        key: id,
        enterFrom: 'left',
        fade: 'inout',
        duration: flagAnimationTime,
        animationTimingFunction: function animationTimingFunction() {
          return easeIn;
        }
      }, function (props) {
        return jsx("div", _extends({}, props, {
          css: css(_templateObject(), baseStyles, isDismissAllowed ? // Transform needed to push up while 1st flag is leaving
          // Exiting time should match the exiting time of motion so is halved
          "\n                    && + * {\n                     transform: translate(0, 0);\n                     transition-duration: ".concat(flagAnimationTime / 2, "ms\n                   }") : '')
        }), flag);
      });
    }) : false;
  };

  var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
  var firstFlagId = null;

  if (hasFlags && children) {
    firstFlagId = Array.isArray(children) ? children[0].props.id : children.props.id;
  }

  var api = {
    onDismissed: onDismissed,
    dismissAllowed: function dismissAllowed(id) {
      return id === firstFlagId;
    }
  };
  return jsx(FlagGroupContext.Provider, {
    value: api
  }, jsx(Portal, {
    zIndex: layers.flag()
  }, jsx("div", {
    id: id,
    css: css(_templateObject2(), flagBottom, flagLeft, layers.flag())
  }, hasFlags ? jsx(LabelTag, {
    css: css(_templateObject3())
  }, label) : null, jsx(ExitingPersistence, {
    appear: false
  }, renderChildren()))));
};

export default FlagGroup;